import { Fragment, h } from "preact";

import classname from "../../../../foundation/utils/classname";

import OnlyIconButton, { OnlyIconButtonVariant } from "../../OnlyIconButton";

import styles from "./AppMenuButton.module.css";

interface Props {
    class?: string;
    onClick: () => void;
}

function IconMenu() {
    return (
        <>
            <div class={styles.menuButtonLine}/>
            <div class={styles.menuButtonLine}/>
            <div class={styles.menuButtonLine}/>
        </>
    );
}

function AppMenuButton({ class: cssClass, onClick }: Props) {
    return (
        <OnlyIconButton
            variant={OnlyIconButtonVariant.Ninja}
            class={classname(styles.appMenuButton, cssClass)}
            icon={IconMenu}
            onClick={onClick}/>
    );
}

export default AppMenuButton;
